// extracted by mini-css-extract-plugin
export default {"container_card":"style_container_card__-PnQO"};